import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {ApiService} from '../ApiService'
import {ActivationConfigDto} from './type'

class ActivationServiceProvider extends ApiService {
  async getConfig(): Promise<ActivationConfigDto> {
    return await this.get<ActivationConfigDto>(`/v2/activations/config`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const ActivationService = new ActivationServiceProvider()
